export class GenericTableModel {
	baseUrl: string;
	title?: string;
	globalFilters?: boolean;
	addButtonText?: string;
	hasDeleteAction?: boolean;
	hasCustomActions?: boolean;
	showRowsPerPageOptions?: boolean;
	rowsPerPageOptions?: number[];
	showFooter?: boolean;
	classStyles?: string;
	showCurrentPageReport?: boolean;
	currentPageReportTemplate?: string;
	confirmationDialogSize?: string;
	customActions?: any[];
	resultKey? : string;
	extraParams?: any;
	disabled?: boolean;

	constructor() {
		this.baseUrl = '';
		this.title = '';
		this.globalFilters = true;
		this.addButtonText = '';
		this.hasDeleteAction = true;
		this.hasCustomActions = false;
		this.showRowsPerPageOptions = true;
		this.rowsPerPageOptions = [10, 25, 50];
		this.showCurrentPageReport = true;
		this.showFooter = false;
		this.showCurrentPageReport = true;
		this.currentPageReportTemplate = 'Showing {first} to {last} of {totalRecords} entries';
		this.confirmationDialogSize = '50vw';
		this.resultKey = 'data';
		this.disabled = false;
	}
}
